<template>
  <div style="width: 100%; height: 100%">
    <div :class="[!inFullScreen ? 'jtCardDefault' : 'jtCardMax']">
      <div id="topBar">
        <q-btn
          v-if="shouldShowFullscreen"
          flat
          round
          color="primary"
          :icon="inFullScreen ? 'fullscreen_exit' : 'fullscreen'"
          @click="
            () => {
              this.inFullScreen = !this.inFullScreen;
            }
          "
        >
          <q-tooltip>
            {{
              inFullScreen
                ? this.$gettext("DASHBOARD_FULLSCREEN_EXIT")
                : this.$gettext("DASHBOARD_FULLSCREEN")
            }}
          </q-tooltip>
        </q-btn>

        <div></div>

        <q-input
          v-model="dateActual"
          readonly
          :label="labelDate"
          style="max-width: 155px"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer" color="secondary">
              <q-popup-proxy
                ref="qDateProxy"
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="dateActual"
                  minimal
                  default-view="Years"
                  years-in-month-view
                  emit-immediately
                  :mask="mask"
                  @input="onChange"
                  :navigation-max-year-month="dateMax"
                >
                  <div class="row items-center justify-end">
                    <q-btn
                      v-close-popup
                      label="Close"
                      color="primary"
                      flat
                    ></q-btn>
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div id="content">
        <slot />
      </div>
    </div>
    <div class="back" v-if="inFullScreen" />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { CARD_SELECT_TYPES } from '../../shared'

@Component({
  name: 'JtCardDefault',
  props: {
    cardTitle: {
      type: String,
      required: true,
      default: ''
    },
    cardSelectType: {
      type: Number,
      required: false,
      default: CARD_SELECT_TYPES.YEARS
    },
    shouldShowSelectMonth: {
      type: Boolean,
      required: false,
      default: true
    },
    shouldShowSelectDay: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldShowFullscreen: {
      type: Boolean,
      required: false,
      default: true
    },
    options: {
      type: Array,
      required: false,
      default: []
    }
  }
})
export default class JtCardDefault extends Vue {
  selected = { year: false, month: false, day: false };
  close = false;

  inFullScreen = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  defaultOptions = [];

  created () {
    if (this.cardSelectType === CARD_SELECT_TYPES.MONTHS) {
      this.defaultOptions = [
        { label: this.$gettext('MONTH'), value: 0 },
        { label: this.$gettext('JAN'), value: 1 },
        { label: this.$gettext('FEB'), value: 2 },
        { label: this.$gettext('MAR'), value: 3 },
        { label: this.$gettext('APR'), value: 4 },
        { label: this.$gettext('MAY'), value: 5 },
        { label: this.$gettext('JUN'), value: 6 },
        { label: this.$gettext('JUL'), value: 7 },
        { label: this.$gettext('AUG'), value: 8 },
        { label: this.$gettext('SEP'), value: 9 },
        { label: this.$gettext('OCT'), value: 10 },
        { label: this.$gettext('NOV'), value: 11 },
        { label: this.$gettext('DEC'), value: 12 }
      ]
    } else if (this.cardSelectType === CARD_SELECT_TYPES.YEARS) {
      let currentYear = new Date().getFullYear()
      this.defaultOptions.push({ label: this.$gettext('YEAR'), value: 0 })
      for (let i = 0; i < 100; i++) {
        this.defaultOptions.push(currentYear)
        currentYear--
      }
    }
  }

  mounted () {
    this.mask = this.shouldShowSelectDay
      ? 'DD-MMMM/YYYY'
      : this.shouldShowSelectMonth
        ? 'MMMM/YYYY'
        : 'YYYY'
    this.labelDate = this.shouldShowSelectDay
      ? 'Dia-Mês/Ano'
      : this.shouldShowSelectMonth
        ? 'Mês/Ano'
        : 'Ano'
    const month = this.defaultOptions[this.currentDate.month].label
    this.dateActual = this.shouldShowSelectDay
      ? this.currentDate.day + '-' + month + '/' + this.currentDate.year
      : this.shouldShowSelectMonth
        ? month + '/' + this.currentDate.year
        : this.currentDate.year
    this.dateMax =
      this.currentDate.year +
      '/' +
      this.currentDate.month +
      '/' +
      this.currentDate.day
  }

  get computedOptions () {
    if (
      [CARD_SELECT_TYPES.MONTHS, CARD_SELECT_TYPES.YEARS].includes(
        this.cardSelectType
      )
    ) {
      return this.defaultOptions
    } else {
      return [
        { label: this.$gettext('SELECT_AN_OPTION'), value: 0 },
        ...this.options
      ]
    }
  }

  onChange (value, reason, details) {
    if (reason === 'year') {
      this.selected.year = true
    }
    if (reason === 'month') {
      this.selected.month = true
    }
    if (reason.includes('day')) {
      this.selected.day = true
    }
    if (
      this.selected.year &&
      (this.shouldShowSelectMonth ? this.selected.month : true) &&
      (this.shouldShowSelectDay ? this.selected.day : true)
    ) {
      this.$refs.qDateProxy.hide()
      this.selected = { year: false, month: false, day: false }

      details.day = !this.shouldShowSelectDay ? 1 : details.day
      details.month = !this.shouldShowSelectMonth ? 1 : details.month

      this.$emit('change', details)
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.jtCardDefault {
  width: 100%;
  height: 100%;

  #topBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
  }

  #content {
    width: 100%;
    height: calc(100% - 30px);
  }
}

.jtCardMax {
  height: 80%;
  width: 90%;
  font-size: x-large;
  background-color: white;
  padding: 40px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;

  #topBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
  }

  #content {
    width: 100%;
    height: calc(100% - 30px);
  }
}

.back {
  background-color: black;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.7;
}
</style>
